import { Descriptions, Divider, Drawer, Dropdown, Spin } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import svg87 from "../../../../assets/svg/svg87.svg";
import svg88 from "../../../../assets/svg/svg88.svg";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import { useSelector } from "react-redux";
import svg92 from "../../../../assets/svg/svg92.svg";
import svg85 from "../../../../assets/svg/svg85.svg";
import { formatPathJpa, previewPaperApplicant } from "../../../../utils";
import DocumentTable from "./documents-applicants/DocumentTable";

function Review({ handleBack, form, fileUrlCover, fileUrlCv }) {
  const navigate = useNavigate();
  const { saving } = useSelector((state) => state.auth);
  const { applicantObj } = useSelector((state) => state.folder);
  const { open, handleCancel, handleOpen } = useModalToggle();
  const { docs } = useSelector((state) => state.folder);
  const items1 = [
    {
      key: "1",
      label: "First Name",
      children: applicantObj?.japFirstName ?? "N/A",
    },

    {
      key: "2",
      label: "Last Name",
      children: applicantObj?.japLastName ?? "N/A",
    },
    {
      key: "3",
      label: "Email",
      children: applicantObj?.japEmail ?? "N/A",
    },
    {
      key: "4",
      label: "Phone",
      children: applicantObj?.japPhone ?? "N/A",
    },
    {
      key: "8",
      label: "Address",
      children: applicantObj?.japAddress ?? "N/A",
    },
    {
      key: "8",
      label: "Gender",
      children: applicantObj?.japGender ?? "N/A",
    },
    {
      key: "9",
      label: "Nationality",
      children: applicantObj?.japNationality ?? "N/A",
    },
    {
      key: "10",
      label: "Are you PLWD?",
      children: applicantObj?.japIsPLWD ?? "N/A",
    },
    {
      key: "6",
      label: "Date of Birth",
      children: (
        <div>
          {applicantObj?.japDob
            ? moment(applicantObj?.japDob)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
  ];
  const items2 = [
    {
      key: "5",
      label: "Are You available Immediately?",
      children: applicantObj?.japIsAvailable ? "Yes" : "No",
    },
    {
      key: "1",
      label: "Notice Period",
      children: applicantObj?.japNoticePeriod ?? "N/A",
    },
    {
      key: "2",
      label: "Why are you interested in this position?",
      children: applicantObj?.japInterestDesc ?? "N/A",
    },
  ];

  const handlePrev = async () => {
    await handleBack();
  };

  return (
    <div className="w-full mt-[2.5rem]">
      <Descriptions
        title="Personal Information"
        column={2}
        colon={false}
        items={items1}
        layout="vertical"
      />
      <div className="py-[2.5rem] flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-[#0E0E0E] text-[.875rem] font-[400] font-dmSans">
            Cv
          </div>
          {fileUrlCv && (
            <div className="flex items-center justify-between mt-[1rem] ">
              <div
                className="flex items-center gap-[.75rem] underline cursor-pointer"
                onClick={() => previewPaperApplicant(fileUrlCv)}
              >
                <img
                  src={svg87}
                  alt="svg87"
                  className="w-[1.375rem] h-[1.375rem]"
                />
                {formatPathJpa(fileUrlCv)}
              </div>
              <img
                className="lg:ml-[3rem] ml-[1rem] cursor-pointer"
                src={svg88}
                alt="svg88"
                onClick={() => previewPaperApplicant(fileUrlCv)}
              />
            </div>
          )}
        </div>

        <div className="flex flex-col">
          <div className="text-[#0E0E0E] text-[.875rem] font-[400] font-dmSans">
            Cover Letter
          </div>
          {fileUrlCover && (
            <div className="flex items-center justify-between mt-[1rem] w-full">
              <div
                className="flex items-center gap-[.75rem] underline cursor-pointer"
                onClick={() => previewPaperApplicant(fileUrlCover)}
              >
                <img
                  src={svg87}
                  alt="svg87"
                  className="w-[1.375rem] h-[1.375rem]"
                />
                {formatPathJpa(fileUrlCover)}
              </div>

              <img
                className="lg:ml-[3rem] ml-[1rem] cursor-pointer"
                src={svg88}
                alt="svg88"
                onClick={() => previewPaperApplicant(fileUrlCover)}
              />
            </div>
          )}
        </div>
      </div>
      <Descriptions
        title=""
        column={1}
        colon={false}
        items={items2}
        layout="vertical"
      />

      <DocumentTable review={true} dataView={docs} />

      <div className="flex   lg:flex-row flex-col lg:items-center justify-between lg:gap-0  gap-5   w-full mt-[2.5rem]">
        <div
          className="flex items-center text-[#706F6F] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
          onClick={() => handlePrev()}
        >
          <img src={svg85} alt="svg85" /> Back
        </div>
        <div className="justify-end flex items-center gap-x-2">
          <div className="w-[100px]">
            <button
              key="back"
              type="button"
              className="cstm-btn-2"
              onClick={() => handlePrev()}
            >
              Cancel
            </button>
          </div>

          <div className="w-[200px]">
            <button
              key="submit"
              type="submit"
              className={`cstm-btn `}
              disabled={saving}
            >
              <span className="flex items-center  gap-x-3 ">
                {saving ? <Spin /> : "Submit"} <img src={svg92} alt="svg92" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Review;
